const Base = (props) => {
  return (
    <mesh position={[0, -9.5, props.posZ]} {...props} receiveShadow>
      <boxGeometry args={[8, 1, 8]} />
      <meshStandardMaterial metalness={0} roughness={0.2} color="rgb(0,46,187)" />
    </mesh>
  );
}

export default Base;